import { render } from "./PlansUpdateOffcanvas.vue?vue&type=template&id=db5a22aa&scoped=true"
import script from "./PlansUpdateOffcanvas.vue?vue&type=script&lang=js"
export * from "./PlansUpdateOffcanvas.vue?vue&type=script&lang=js"

import "./PlansUpdateOffcanvas.vue?vue&type=style&index=0&id=db5a22aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db5a22aa"]])

export default __exports__